export default function ChevronDownIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="chevron-down"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 21}
      height={height ? height : width ? width : 21}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M24 30.6q-.4 0-.75-.15T22.6 30l-9.9-9.9q-.55-.55-.525-1.4.025-.85.575-1.4.65-.65 1.425-.575.775.075 1.375.625L24 25.8l8.45-8.45q.55-.55 1.425-.6.875-.05 1.425.6.65.55.575 1.375-.075.825-.625 1.425L25.4 30q-.3.3-.65.45-.35.15-.75.15Z"
      />
    </svg>
  );
}
